import api from 'api'

export const removeProject = async (id) => {
  const { data } = await api.delete(`/project/${id}`)

  return data
}
